import React, { useState, useEffect } from "react";
import "./Clients.css";
import AddClientOverlay from "../components/adclient/AddClientOverlay";
import ClientManagementSkeletonDemo from "../components/skeletionLoaders/ClientSkeleton";
import ClientDetailPage from "../components/clientdetails/ClientDetailPage";

const Clients = ({ agentData }) => {
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showVisitModal, setShowVisitModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [operationLoading, setOperationLoading] = useState(false);
  const [openStatusClientId, setOpenStatusClientId] = useState(null);
  const [viewSelectedClientDetails, setViewSelectedClientDetails] = useState(false);
  const [selectedWebstoreUser, setSelectedWebstoreUser] = useState(null);

  // Mock clients data
  const [clients, setClients] = useState([]);

  useEffect(() => {
    fetchClientsFromServer();
  }, []);

  const tabs = [
    { id: "all", label: "All Clients", count: clients.length },
    { id: "lead", label: "Leads", count: clients.filter((c) => c.status === "lead").length },
    { id: "new", label: "New", count: clients.filter((c) => c.status === "new").length },
    { id: "converted", label: "Converted", count: clients.filter((c) => c.status === "converted").length },
    { id: "followup", label: "Follow-up", count: clients.filter((c) => c.followUpRequired).length },
  ];

  const getFilteredClients = () => {
    let filtered = clients;

    if (activeTab === "followup") {
      filtered = clients.filter((c) => c.followUpRequired);
    } else if (activeTab !== "all") {
      filtered = clients.filter((c) => c.status === activeTab);
    }

    if (searchQuery) {
      filtered = filtered.filter(
        (c) =>
          c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          c.businessCategories.toLowerCase().includes(searchQuery.toLowerCase()) ||
          c.phone.includes(searchQuery) ||
          c.location.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    return filtered;
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      lead: { label: "Lead", color: "#f59e0b", bg: "#fef3c7" },
      new: { label: "New", color: "#3b82f6", bg: "#dbeafe" },
      converted: { label: "Converted", color: "#10b981", bg: "#d1fae5" },
    };
    const config = statusConfig[status] || statusConfig.lead;
    return (
      <span className='sl-agent-client-badge' style={{ color: config.color, background: config.bg }}>
        {config.label}
      </span>
    );
  };

  const getPosTypeBadge = (posType) => {
    if (!posType) return <span className='sl-agent-pos-badge sl-agent-pos-none'>No POS</span>;
    return (
      <span className={`sl-agent-pos-badge sl-agent-pos-${posType}`}>
        {posType === "purchased" ? "✓ Purchased" : posType === "installment " ? "Installment" : "📦 Leased"}
      </span>
    );
  };

  const handleMarkAs = async (clientId, newStatus) => {
    try {
      setOperationLoading(true);
      let url = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/updateClientStatus";
      const storedAgent = localStorage.getItem("agentData");
      if (!storedAgent) {
        console.error("No agent data found in login again");
        setIsLoading(false);
        return;
      }
      const agentID = JSON.parse(storedAgent)._id;
      let response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ agentID, clientID: clientId, newStatus }),
      });

      let data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to update client status");
      }

      console.log("Update Client Status Response Data:", data.updatedClient);
      localStorage.setItem("agentData", JSON.stringify(data.updatedMarketingAgent));
      setClients(clients.map((c) => (c.id === clientId ? { ...c, status: newStatus } : c)));
      setOpenStatusClientId(null);

      alert("Client status updated successfully!");
    } catch (error) {
      console.error("Error updating client status:", error);
      alert("Failed to update client status. Please try again.");
      return;
    } finally {
      setOperationLoading(false);
    }
  };

  const handleToggleFollowUp = async (clientId, isFollowRequested) => {
    if (isFollowRequested) {
      // Remove follow-up
      // setClients(clients.map((c) => (c.id === clientId ? { ...c, followUpRequired: false } : c)));

      try {
        setOperationLoading(true);
        let url = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/cancelClientFollowUp";
        const storedAgent = localStorage.getItem("agentData");
        if (!storedAgent) {
          console.error("No agent data found in login again");
          setIsLoading(false);
          return;
        }
        const agentID = JSON.parse(storedAgent)._id;

        let response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ agentID, clientID: clientId }),
        });
        let data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "Failed to remove follow-up request");
        }
        console.log("Remove Follow-up Response Data:", data.updatedClient);
        setClients(clients.map((c) => (c.id === clientId ? { ...c, followUpRequired: false } : c)));
        localStorage.setItem("agentData", JSON.stringify(data.updatedMarketingAgent));
        alert("Follow-up request cancelled successfully!");
      } catch (error) {
        console.error("Error removing follow-up request:", error);
        alert("Failed to remove follow-up request. Please try again.");
        return;
      } finally {
        setOperationLoading(false);
        return;
      }
    }
    try {
      setOperationLoading(true);
      let url = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/requestClientFollowUp";
      const storedAgent = localStorage.getItem("agentData");
      if (!storedAgent) {
        console.error("No agent data found in login again");
        setIsLoading(false);
        return;
      }
      const agentID = JSON.parse(storedAgent)._id;
      //follow up date is in 7days from now
      let now = new Date();
      let followUpDate = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);

      let response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ agentID, clientID: clientId, followUpDate }),
      });

      let data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to update follow-up status");
      }
      console.log("Update Follow-up Response Data:", data.updatedClient);

      setClients(clients.map((c) => (c.id === clientId ? { ...c, followUpRequired: true } : c)));

      localStorage.setItem("agentData", JSON.stringify(data.updatedMarketingAgent));
      alert("Follow-up status updated successfully!");
    } catch (error) {
      console.error("Error updating follow-up status:", error);
      alert("Failed to update follow-up status. Please try again.");
    } finally {
      setOperationLoading(false);
    }
  };

  const handleRegisterVisit = (client) => {
    setSelectedClient(client);
    setShowVisitModal(true);
  };

  const confirmVisit = async () => {
    if (selectedClient) {
      try {
        let url = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/registerClientVisit";
        const storedAgent = localStorage.getItem("agentData");

        if (!storedAgent) {
          console.error("No agent data found in login again");
          setIsLoading(false);

          return;
        }
        const agentID = JSON.parse(storedAgent)._id;

        let response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ agentID, clientID: selectedClient.id }),
        });
        let data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "Failed to register visit");
        }
        console.log("Register Visit Response Data:", data.updatedClient);
        setClients(
          clients.map((c) =>
            c.id === selectedClient.id
              ? {
                  ...c,
                  visits: c.visits + 1,
                  lastVisit: new Date().toISOString().split("T")[0],
                }
              : c
          )
        );
        // set agent data in local storage
        let agentData = data.updatedMarketingAgent;
        localStorage.setItem("agentData", JSON.stringify(agentData));
        alert("Visit registered successfully!");
      } catch (error) {
        console.error("Error registering visit:", error);
        alert("Failed to register visit. Please try again.");
      }

      setShowVisitModal(false);
      setSelectedClient(null);
    }
  };

  const handleCreateNewClient = async (newClient) => {
    console.log("New Client Data:", newClient);
    setIsLoading(true);
    const storedAgent = localStorage.getItem("agentData");

    if (!storedAgent) {
      console.error("No agent data found in login again");
      setIsLoading(false);
      return;
    }
    const agentID = JSON.parse(storedAgent)._id;
    console.log("Agent ID:", agentID);

    const createClientUrl = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/createClient";

    try {
      let payload = {
        clientName: newClient.clientName,
        isClientInterestedInHardware: newClient.interestedInHardware,
        clientPhoneNumber: newClient.phoneNumber,
        isClientInterestedInSoftware: newClient.interestedInSoftware,
        didClientRequestADemo: newClient.requestedDemo,
        shopAddress: newClient.shopAddress,
        shopLocation: newClient.town,
        businessCategory: newClient.businessCategory,
      };

      let response = await fetch(createClientUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ newClient: payload, agentID }),
      });

      let data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to create new client");
      }
      console.log("Create Client Response Data:", data);
      const transformedClients = transformClients(data.marketingAgent.clients);
      console.log("Transformed Clients:", transformedClients);
      setClients(transformedClients);

      localStorage.setItem("agentData", JSON.stringify(data.marketingAgent));
      alert("Client created successfully!");
    } catch (error) {
      console.log("Error creating new client:", error);
      alert("Failed to create client. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClientsFromServer = async () => {
    setIsLoading(true);
    try {
      let storedAgent = localStorage.getItem("agentData");
      if (!storedAgent) {
        console.error("No agent data found. Please log in again.");
        return;
      }
      let agentID = JSON.parse(storedAgent)._id;
      const fetchClientsUrl = process.env.REACT_APP_Back_end_api_root + "/marketingAgentApp/clients/" + agentID;
      let response = await fetch(fetchClientsUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      let data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch clients");
      }
      console.log("Fetched Clients Data: ", data);

      const transformedClients = transformClients(data.clients);
      console.log("Fetched and Transformed Clients:", transformedClients);

      setClients(transformedClients);
    } catch (error) {
      console.error("Error fetching clients:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <ClientManagementSkeletonDemo />
      ) : viewSelectedClientDetails ? (
        <ClientDetailPage
          client={selectedClient}
          webstoreUser={selectedWebstoreUser}
          onBack={() => {
            setViewSelectedClientDetails(false);
          }}
          setClients={setClients}
          setSelectedWebstoreUser={setSelectedWebstoreUser}
        />
      ) : (
        <div className='sl-agent-clients-container'>
          {/* Header */}
          <div className='sl-agent-clients-header'>
            <div>
              <h1>Client Management</h1>
              <p>Manage your clients, track visits, and monitor conversions</p>
            </div>
            <button className='sl-agent-add-client-btn' onClick={() => setShowAddModal(true)}>
              <span>➕</span>
              Add Client
            </button>
          </div>

          {/* Search and Filter */}
          <div className='sl-agent-clients-controls'>
            <div className='sl-agent-search-box'>
              <span className='sl-agent-search-icon'>🔍</span>
              <input
                type='text'
                placeholder='Search clients by name, phone, or address...'
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {/* Tabs */}
          <div className='sl-agent-clients-tabs'>
            {tabs.map((tab) => (
              <button key={tab.id} className={`sl-agent-tab-btn ${activeTab === tab.id ? "sl-agent-tab-active" : ""}`} onClick={() => setActiveTab(tab.id)}>
                {tab.label}
                <span className='sl-agent-tab-count'>{tab.count}</span>
              </button>
            ))}
          </div>

          {/* Clients List */}
          <div className='sl-agent-clients-list'>
            {getFilteredClients().length === 0 ? (
              <div className='sl-agent-empty-state'>
                <div className='sl-agent-empty-icon'>📭</div>
                <h3>No clients found</h3>
                <p>Try adjusting your filters or add a new client</p>
              </div>
            ) : (
              getFilteredClients().map((client) => (
                <div key={client.id} className='sl-agent-client-card'>
                  <div className='sl-agent-client-header'>
                    <div className='sl-agent-client-left'>
                      <div className='sl-agent-client-avatar'>{client.name.charAt(0)}</div>
                      <div className='sl-agent-client-info'>
                        <div className='sl-agent-client-title-row'>
                          <h3 className='sl-agent-client-name'>{client.name}</h3>
                          {client.followUpRequired && (
                            <span className='sl-agent-followup-badge'>
                              <span className='sl-agent-badge-icon'>⚠️</span> Follow-up
                            </span>
                          )}
                        </div>
                        <p className='sl-agent-client-contact'>{client.businessCategories}</p>
                        <div className='sl-agent-client-contact-row'>
                          <span className='sl-agent-contact-item'>
                            <span className='sl-agent-icon'>📞</span> {client.phone}
                          </span>
                          {/*   <span className='sl-agent-contact-item'>
                          <span className='sl-agent-icon'>✉️</span> {client.email}
                        </span> */}
                          <span className='sl-agent-contact-item'>
                            <span className='sl-agent-icon'>📍</span>
                            {client.shopAddress + ","} {client.location}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='sl-agent-client-stats-row'>
                    <div className='sl-agent-stat-item'>
                      <span className='sl-agent-stat-label'>STATUS</span>
                      {getStatusBadge(client.status)}
                    </div>
                    <div className='sl-agent-stat-item'>
                      <span className='sl-agent-stat-label'>POS</span>
                      {getPosTypeBadge(client.posType)}
                    </div>
                    <div className='sl-agent-stat-item'>
                      <span className='sl-agent-stat-label'>VISITS</span>
                      <span className='sl-agent-stat-number'>{client.visits}</span>
                    </div>
                    <div className='sl-agent-stat-item'>
                      <span className='sl-agent-stat-label'>REVENUE</span>
                      <span className='sl-agent-stat-number'>₦{client.revenue.toLocaleString()}</span>
                    </div>
                  </div>

                  <div className='sl-agent-client-actions'>
                    <div className='sl-agent-action-dropdown'>
                      <button
                        onClick={() => {
                          setOpenStatusClientId(openStatusClientId === client.id ? null : client.id);
                        }}
                        className='sl-agent-action-btn sl-agent-mark-btn'
                      >
                        <span>Mark as</span>
                        <span className='sl-agent-dropdown-icon'>▼</span>
                      </button>
                      {openStatusClientId === client.id && (
                        <div key={client.id} className='sl-agent-dropdown-menu'>
                          <button onClick={() => handleMarkAs(client.id, "lead")}>Lead</button>
                          <button onClick={() => handleMarkAs(client.id, "new")}>New</button>
                          <button onClick={() => handleMarkAs(client.id, "converted")}>Converted</button>
                        </div>
                      )}
                    </div>
                    <button className='sl-agent-action-btn sl-agent-visit-btn' onClick={() => handleRegisterVisit(client)}>
                      <span className='sl-agent-btn-icon'>📍</span>
                      <span>Visit</span>
                    </button>
                    <button
                      className={`sl-agent-action-btn sl-agent-followup-btn ${client.followUpRequired ? "sl-agent-btn-remove" : ""}`}
                      onClick={() => handleToggleFollowUp(client.id, client.followUpRequired)}
                    >
                      <span className='sl-agent-btn-icon'>⚠️</span>
                      <span>{client.followUpRequired ? "Remove" : "Follow-up"}</span>
                    </button>
                    <button
                      onClick={() => {
                        setSelectedClient(client);
                        setSelectedWebstoreUser(client.webstoreUser);
                        setViewSelectedClientDetails(true);
                      }}
                      className={`sl-agent-action-btn `}
                    >
                      View Client Details
                    </button>
                    <button
                      onClick={() => {
                        const storedAgent = localStorage.getItem("agentData");

                        if (!storedAgent) {
                          console.error("No agent data found in login again");
                          setIsLoading(false);
                          return;
                        }
                        const agentLink = `${JSON.parse(storedAgent).referralLink}&client=${client.id}`;
                        console.log("Agent Link:", agentLink);

                        window.open(agentLink, "_blank");
                      }}
                      className='sl-agent-action-btn sl-agent-details-btn'
                    >
                      Sign client up
                      <span className='sl-agent-btn-icon'>➡️</span>
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Visit Modal */}
          {showVisitModal && selectedClient && (
            <div className='sl-agent-modal-overlay' onClick={() => setShowVisitModal(false)}>
              <div className='sl-agent-modal' onClick={(e) => e.stopPropagation()}>
                <h3>Register Visit</h3>
                <p>
                  Confirm visit to <strong>{selectedClient.name}</strong>?
                </p>
                <div className='sl-agent-modal-info'>
                  <div>
                    Current visits: <strong>{selectedClient.visits}</strong>
                  </div>
                  <div>
                    Last visit: <strong>{selectedClient.lastVisit}</strong>
                  </div>
                </div>
                <div className='sl-agent-modal-actions'>
                  <button className='sl-agent-modal-btn sl-agent-btn-secondary' onClick={() => setShowVisitModal(false)}>
                    Cancel
                  </button>
                  <button className='sl-agent-modal-btn sl-agent-btn-primary' onClick={confirmVisit}>
                    Confirm Visit
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {<AddClientOverlay isOpen={showAddModal} onClose={() => setShowAddModal(false)} onSubmit={handleCreateNewClient} />}
    </>
  );
};

export default Clients;

export function transformClients(rawClients = []) {
  return rawClients.map((client, index) => ({
    id: client._id || index + 1,
    name: client.clientName,
    businessCategories: client.businessCategory,
    phone: client.clientPhoneNumber,
    status: client.status,
    posType: client.POScontract === "none" ? null : client.POScontract,
    visits: client.visits ?? 0,
    lastVisit: client.lastVisitDate ? new Date(client.lastVisitDate).toISOString().split("T")[0] : null,
    joinDate: client.contactDate ? new Date(client.contactDate).toISOString().split("T")[0] : null,
    followUpRequired: Boolean(client.followUpDate),
    revenue: client.generatedRenvenueForAgent ?? 0,
    location: client.shopLocation,
    didClientRequestADemo: client.didClientRequestADemo,
    isClientInterestedInHardware: client.isClientInterestedInHardware,
    isClientInterestedInSoftware: client.isClientInterestedInSoftware,
    shopAddress: client.shopAddress,
    pendingPaymentAmount: client.pendingPaymentAmount || 0,
    webstoreUser: client.webstoreUserID || null,
    clientEmail: client.clientEmail || "",
    shopLocation: client.shopLocation || "",
    POScontract: client.POScontract || "none",
    generatedRevenueForAgent: client.generatedRenvenueForAgent || 0,
    pendingPaymentAmount: client.pendingPaymentAmount || 0,
    contactDate: client.contactDate,
    conversionDate: client.conversionDate || null,
    lastVisitDate: client.lastVisitDate || null,
    followUpDate: client.followUpDate || null,
    notes: client.notes || "Not provided",
  }));
}
